import CryptoJS from "crypto-js";

const hash = process.env.REACT_APP_URL_ORIGEM.concat(process.env.REACT_APP_URL_ORIGEM.length).concat(process.env.REACT_APP_API_URL).concat(process.env.REACT_APP_API_URL.length-2);

export const hashCode = (text) => {
  return CryptoJS.AES.encrypt(CryptoJS.enc.Latin1.parse(text), hash);
}

export const hashDecode = (text) => {
  return CryptoJS.AES.decrypt(text, hash).toString(CryptoJS.enc.Latin1);
}

export const hashMD5 = (text) => {
  return CryptoJS.MD5(text).toString();
}
